import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full mx-auto mt-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"10rem"},
  class: "material-icons-outlined opacity-10"
}, " error_outline ", -1)
const _hoisted_3 = { class: "opacity-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("errors.404")), 1),
    _createVNode(_component_Btn, {
      class: "mt-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("errors.back")), 1)
      ]),
      _: 1
    })
  ]))
}